/*
 * The quiz generator asks for a true/false count and a multiple choice count.
 * Between them they decide both the size of the quiz and the mix of questions
 * it asks for.
 */

/**
 * Adds the two counts, treating a blank box as zero.
 * @param {Object} split The { trueFalseCount, multipleChoiceCount } counts
 * @returns {Number} The total number of questions requested
 */
export const getQuestionTotal = ({ trueFalseCount, multipleChoiceCount }) =>
  Number(trueFalseCount || 0) + Number(multipleChoiceCount || 0);

/**
 * Returns the message shown under the question count boxes, or an empty string
 * when the counts are usable.
 * @param {Object} params The current counts
 * @param {Number} params.total The two counts added together
 * @param {Number} params.maxQuestions The most questions a single quiz may request
 * @returns {String} The error message, or an empty string
 */
export const getQuestionCountError = ({ total, maxQuestions }) => {
  if (total < 1) return 'Enter at least 1 question to generate a new quiz';
  if (total > maxQuestions) {
    return `Total number of questions cannot be greater than ${maxQuestions}`;
  }
  return '';
};
